import Vue from 'vue'
/* 日期格式化为YY-MM-DD hh:mm:ss
入参：YY-MM-DDThh:mm:ss
*/
Vue.filter("formatTime",(value)=>{
	if(value){
		if(value.indexOf('T')!=-1){
			return value.replace("T"," ")
		}
	}else{
		return "暂无";
	}
});
/* 日期格式化为YY-MM-DD 
入参：YY-MM-DD hh:mm:ss
*/
Vue.filter("formatDate",(value)=>{
	if(value){
		return value.substr(0,10)
	}else{
		return "暂无";
	}
});


